<template>
  <div>
      <!----select stages ----->
      <div class="row">
        <div class="col-md-12">
          <button type="button"
                  class="btn btn-light btn-sm back"
                  @click.prevent="hideMands(true)">
            <i class="material-icons mdc-button__icon">arrow_back</i>
            <span>{{'buttons.back' | trans}}</span>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h1 v-if="this.isNew && !this.protocol.isDraft" class="page-title">
            {{'protocol.newProtocol' |
            trans}}</h1>
          <h1 v-if="!this.isNew && !this.protocol.isDraft" class="page-title">
            {{'protocol.editProtocol' |
            trans}}</h1>
          <h1 v-if="this.protocol.isDraft" class="page-title">
            {{'protocol.auto_save_version' | trans}} {{protocol.updatedAt.date |
            toLocaleDateTime}}</h1>
          <h3 class="page-sub-title">
            {{currentStage.title}}: {{currentStage.description}}</h3>
        </div>
      </div>

      <div class="alert alert-secondary mt-2">
        <div class="form-group row">
          <div class="col-md-12">
            <h4 class="row-title">{{'protocol.stimuluses' | trans}}</h4>
            <h5 class="row-title_subsitle mb-4">{{'protocol.change_stimul_position' | trans}}</h5>
          </div>

          <div class="tasks col-md-12" id="mands" v-if="mands">
            <table class="table table-sm">
              <thead>
              <tr>
                <th>{{'protocol.name_mand_reaction' | trans}}</th>
                <th>{{'protocol.show_on_stage' | trans}}</th>
                <th v-if="(isCurator || isBCBA) && protocol.assigneeId">{{'protocol.mastered_mand' | trans}}</th>
                <th v-if="(isCurator || isBCBA) && protocol.assigneeId">{{'protocol.recommendation' | trans}}</th>
                <th></th>
              </tr>
              </thead>
              <draggable
                  :list="mands"
                  ghost-class="ghost"
                  tag="tbody"
                  @start="dragging = true"
                  @end="dragging = false"
                  handle=".drag-btn"
              >
                <tr v-for="mand in mands" :key="mand.globalUuid">
                  <td class="name-field">
                    {{mand.description}}
                  </td>
                  <td class="table-actions">
                    <mdc-checkbox v-model="mand.active"/>
                  </td>
                  <td class="table-actions" v-if="(isCurator || isBCBA) && protocol.assigneeId">
                    <mdc-checkbox v-model="mand.mastered" @change="masteredMand(mand)"/>
                  </td>
                  <td class="table-actions text-center" v-if="(isCurator || isBCBA) && protocol.assigneeId">
                    <span v-if="mand.canBeMarkedAsMastered">{{'report.mastered' | trans}}</span>
                    <span v-if="!mand.canBeMarkedAsMastered">{{'protocol.buttons.no' | trans}}</span>
                  </td>
                  <td class="text-right action-cell">
                    <span class="drag-btn align-top"  v-if="mand.active">draggable</span>
                  </td>
                </tr>
              </draggable>

            </table>


          </div>

          <div class="col-10 col-md-11">
            <mdc-textfield type="text"
                           :label="'protocol.buttons.addMandReaction' | trans"
                           name="addMandReactionItem"
                           :class="{'is-invalid': errors.has('addMandReactionItem')}"
                           v-validate="'max:1000'"
                           v-model="addMandReactionItem"
                           data-vv-validate-on="none"
                           :data-vv-as="'protocol.buttons.addMandReaction' | trans"/>
            <span class="invalid-feedback"
                  v-if="errors.has('addMandReactionItem')">
                      <strong>{{ errors.first('addMandReactionItem') }}</strong>
                  </span>

          </div>
          <div class="col-2 col-md-1">
            <button type="button"
                    class="btn btn-sm btn-rounded btn-add-grey"
                    @click.prevent="addMand(addMandReactionItem)">
              <i class="material-icons button-primary btn-fixed">add</i>
            </button>
          </div>

          <!----------- tasks ------------------->
        </div>
      </div>

      <div class="row form-group">
        <div class="col-md-12">

          <div class="box-shadow">
            <div class="row">
              <div class="col-md-7">

                 <div class="half_box-block mb-4">
                    <h3 class="title-block">{{'protocol.tracked_reactions' | trans}}</h3>
                    <p class="text-danger" v-if="errorRecordedReactionsList">{{'protocol.tracked_reactions' | trans}} обязательны</p>
                    <div v-for="type in recordedReactionsList" class="mb-2">
                      <mdc-checkbox v-model="type.checked" :label="labelMand(type.placeholder, type.description )"  @change="changeRecordedReactions"/>
                    </div>

                   <div class="choose-input-block">
                     <h3 class="title-block">{{'report.condition_mastered' | trans}}</h3>

                     <div class="select-wrapp" v-if="masteringConditionAnswer">
                       <v-select name="teachingMethod"
                                 :options="masteringCondition"
                                 :filterable="false"
                                 label="id"
                                 v-model="masteringConditionAnswer">
                         <template slot="option" slot-scope="option">
                           {{ option.title}}
                         </template>
                         <template slot="selected-option" slot-scope="option">
                           {{ option.title }}
                         </template>
                       </v-select>
                     </div>
                     <input id="condition_procent"
                                    ref="condition_procent"
                                    min=80
                                    type="number"
                                    v-on:keydown="changeNumber"
                                    name="condition_procent"
                                    :class="{'is-invalid': errors.has('condition_procent')}"
                                    v-model=currentStage.masteringCondition.ratio
                                    v-validate="'min_value:80|max_value:100|numeric'"
                                    data-vv-validate-on="none"
                                    :data-vv-as="'protocol.condition_procent' | trans"/>
                     % {{'protocol.condition_mastered' | trans }}

                     <input id="condition_session"
                                    ref="condition_session"
                                    min=1
                                    class="ml-2"
                                    type="number"
                                    v-on:keydown="changeNumber"
                                    name="condition_session"
                                    :class="{'is-invalid': errors.has('condition_session')}"
                                    v-model=currentStage.masteringCondition.sessionCount
                                    v-validate="'min_value:1|max_value:10|numeric'"
                                    data-vv-validate-on="none"
                                    :data-vv-as="'protocol.condition_trial' | trans"/>
                     {{'protocol.condition_trial' | trans }}
                     <input id="condition_trial"
                                    ref="condition_trial"
                                    min=1
                                    class="ml-2"
                                    type="number"
                                    v-on:keydown="changeNumber"
                                    name="condition_trial"
                                    :class="{'is-invalid': errors.has('condition_trial')}"
                                    v-model=currentStage.masteringCondition.trialCount
                                    v-validate="'min_value:1|max_value:10|numeric'"
                                    data-vv-validate-on="none"
                                    :data-vv-as="'protocol.condition_session' | trans"/>
                     {{'protocol.condition_session' | trans }}
                   </div>
                   <span class="invalid-feedback invalid"
                                     v-if="errors.has('condition_procent')">
                              <strong>{{errors.first('condition_procent')}}  </strong>
                        </span>
                   <span class="invalid-feedback invalid"
                         v-if="errors.has('condition_session')">
                              <strong>{{errors.first('condition_session')}}  </strong>
                        </span>
                   <span class="invalid-feedback invalid"
                         v-if="errors.has('condition_trial')">
                              <strong>{{errors.first('condition_trial')}}  </strong>
                        </span>

                 </div>
              </div>
              <div class="col-md-5" v-if="isPromptEnableList">
                <mdc-switch v-model="currentStage.isPromptEnabled">
                  {{'protocol.track_change_level' | trans}}
                </mdc-switch>
                <hints :hint-list="currentStage.taskPrompts" :hintVisible="currentStage.isPromptEnabled"/>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <button type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="hideMands(true)"
                  :disabled="disabled">
            {{'protocol.buttons.back_to_protocol' | trans}}
          </button>
        </div>
      </div>

  </div>

</template>

<script>
  import axios from 'axios';
  import lang from '../../../lang/translator';
  import findIndex from 'lodash/findIndex';
  import forEach from 'lodash/forEach';
  import isEmpty from 'lodash/isEmpty';
  import {Validator} from 'vee-validate';
  import forIn from 'lodash/forIn';
  import cloneDeep from 'lodash/cloneDeep';
  import Hints from '../../protocols/components/Hints';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import draggable from 'vuedraggable';
  import trim from 'lodash/trim';
  import map from 'lodash/map';
  import filter from 'lodash/filter';
  import sortBy from 'lodash/sortBy';
  import {mapGetters} from 'vuex';

  export default {
    components: {draggable, Hints},
    props: [
      'protocol',
      'isNew',
      'taskTypes',
      'selectedStagesTitle',
      'changeFromClient'],
    data() {
      return {
        apiUrl: '/protocols/',
        disabled: false,
        currentStageIndex: 0,
        currentStageTitle: '',
        currentStage: {},
        selectedStage: {},
        mands: [],
        mandList: [],
        modal: null,
        mand: null,
        selected: {},
        disabledChange: false,
        stimulList: [],
        isModalVisible: false,
        isStimulVisible: false,
        intervalId: null,
        addMandReactionItem: null,
        recordedReactionsList: [],
        isPromptEnableList: 0,
        errorRecordedReactionsList: false,
        masteringConditions: {
          stageId: null,
          ratio: '100',
          trialCount: '3',
          sessionCount: '1',
          answerDirectory: {id: 1}
        },
        masteringCondition: null,
        masteringConditionAnswer: null
      };
    },
    computed: {
      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
      ]),
    },

    mounted: function() {
      this.$nextTick(function() {
        this.intervalId = window.setInterval(() => {
          this.hideMands();
        }, 5000);

      });
    },

    beforeDestroy() {
      clearInterval(this.intervalId)
    },

    methods: {

      changeNumber(event){
        if (event.shiftKey || !((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 46 || event.keyCode == 8|| (event.keyCode >= 35 && event.keyCode <= 40) )) {
          event.preventDefault();
        }
      },

      fetchMasteringCondition: async function() {
        try {
          let response = await axios.get(this.apiUrl + 'mand/stage-mastering-condition-answer-directories/');
          this.masteringCondition = response.data.data;
          let current = this.masteringCondition[0];

          if (this.currentStage.masteringCondition && this.currentStage.masteringCondition.answerDirectory.id){
            current =  filter(this.masteringCondition, item => {
              return item.id == this.currentStage.masteringCondition.answerDirectory.id;
            })[0];
          }

          this.masteringConditionAnswer = current;
        } catch (error) {
          console.dir(error);
        }
      },

      protocolChanged() {
        this.$emit('protocolChanged');
      },

      labelMand: function(title, description) {
        return  lang.get(title) + ' (' + description + ')';
      },

      masteredMand(mand){
        if (mand.mastered){
          let mandCurrent =  filter(this.mands, function(item) {
            return item.globalUuid == mand.globalUuid;
          })[0];

          mandCurrent.position = this.mands.length + 1;

          this.mands = sortBy(this.mands, 'position');

          this.reindexMands();
        }
      },

      reindexMands: function() {
        this.mands.forEach(function(item, index) {
          let position = (parseInt(index) + 1);
          item['position'] = parseInt(index);
        });

      },

      changeRecordedReactions(){
        let list = filter(this.recordedReactionsList, item => {
          return item.isPrompt && item.checked
        });

        this.isPromptEnableList = list.length
      },

      addMand: function(addMandReactionItem) {
        if (!addMandReactionItem){
          return;
        }

        let unique = true;

        let mandReactionsList = this.protocol.globalMandReactions;

        forIn(mandReactionsList, function(stimul) {
          if (trim(stimul.description.toLowerCase()) ===
              trim(addMandReactionItem.toLowerCase())) {
            unique = false;
          }
        });


        if (unique) {
          this.currentStage.isNew = true;

          let position = parseInt(this.mands.length) + 1;
          let uuid = UuidGenerator.v4();

          this.mands.unshift({
            'position': position,
            'globalUuid': uuid,
            'description': addMandReactionItem,
            'mastered': false,
            'active': true,
          });

          this.protocol.globalMandReactions.push({
            'position': position,
            'mastered': false,
            'title': lang.get('protocol.mands') + ' ' + position,
            'description': addMandReactionItem,
            'active': false,
            'uuid': uuid
          });

          this.addMandReactionItem = null;
          this.changeCanPublish();

        } else {
          this.errors.add({
            field: 'addMandReactionItem',
            msg: lang.get('rotation.unique_stimulus'),
          });
        }
      },

      getCurrentStageIndex: function(title) {
        this.currentStageIndex = findIndex(this.protocol.stages, (stage) => {
          return stage.title === title;
        });

        return this.currentStageIndex;
      },

      changeCanPublish() {
        this.$emit('changeCanPublish');
      },

      hintsUpdate: function() {
        if (this.currentStage.taskPrompts[2].active || this.currentStage.taskPrompts[3].active || this.currentStage.taskPrompts[4].active || this.currentStage.taskPrompts[5].active){
          this.currentStage.taskPrompts[1].active = false;
        }
      },

      async hideMands(hide = false) {

        let result = await this.$validator.validateAll();
        
        if (result){
          this.reindexMands();
          this.hintsUpdate();

          this.currentStage.mands =  filter(this.mands, function(item) {
            return item.active;
          });

          this.currentStage.masteringCondition.answerDirectory = {
            id: this.masteringConditionAnswer.id
          };

          this.currentStage.masteredMands =  filter(this.mands, function(item) {
            return item.mastered;
          });

          let recordedReactionsList =  filter(this.recordedReactionsList, function(item) {
            return item.checked;
          });

          this.currentStage.recordedReactions  = map(recordedReactionsList, (reactions) => {
            return reactions.id
          });

          if(!recordedReactionsList.length){
            this.errorRecordedReactionsList = true;
            return;
          } else{
            this.errorRecordedReactionsList = false;
          }


          setTimeout(() => {
            this.protocol.stages[this.currentStageIndex] = this.currentStage;
            if (hide){
              this.afterLoad = false;
              this.$emit('hideMands');
            }
            this.protocolChanged();
          }, 100);
        }
      
      },

    },

    created() {
      if (this.selectedStagesTitle) {
        this.currentStageIndex = this.getCurrentStageIndex(
            this.selectedStagesTitle);
      }
      this.selected = this.protocol.stages[this.currentStageIndex];
      this.currentStageTitle = this.protocol.stages[this.currentStageIndex].title;
      this.currentStage = cloneDeep(this.protocol.stages[this.currentStageIndex]);


      let mandList = cloneDeep(this.protocol.globalMandReactions);

      this.mands = map(mandList, (mand) => {

        let currentMand = filter(this.currentStage.mands, function(item) {
          return item.globalUuid == mand.uuid;
        });

        mand.active = currentMand.length == 1;
        mand.position = currentMand.length ? currentMand[0].position : mand.position;
        mand.globalUuid = mand.uuid;
        mand.canBeMarkedAsMastered = currentMand.length ? currentMand[0].canBeMarkedAsMastered : false

        mand.mastered = filter(this.currentStage.masteredMands, function(item) {
          return item.globalUuid == mand.uuid;
        }).length == 1;

        delete mand['uuid'];

        return mand;
      });

      this.mands = sortBy(this.mands, 'position');

      this.recordedReactionsList = this.taskTypes[0].answers;

      this.recordedReactionsList = map(this.recordedReactionsList, (reactions) => {

        let currentReaction = findIndex(this.currentStage.recordedReactions, id => { return id == reactions.id; });

        if (currentReaction >= 0){
          reactions.checked = true;
        }

        return reactions
      });

      this.changeRecordedReactions();
      this.fetchMasteringCondition();

      Validator.extend('unique_mand', {
        getMessage: attribute => lang.get('protocol.unique_mand',
            {attribute}),
        validate: async (mand) => {
          let valid;
          let unique = 0;

          forIn(this.mands, function(item) {
            if (item.description === mand) {
              unique++;
            }
          });

          if (unique > 1) {
            valid = false;
          } else {
            valid = true;
          }

          return {valid};
        },
      });
    },


  };
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/TasksMand.vue